import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import Theme from '../../Theme/index.js';

var _templateObject;
var Headline = styled.h1(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  color: ", ";\n  font-size: ", ";\n  font-weight: 500;\n"])), Theme.fonts.Montserrat, Theme.colors.primary, function (props) {
  return props.fontSize || "16px";
});

export { Headline };
